import React, {useState} from "react";
import ModalBase from "./ModalBase";
import {Button, Col, Row} from "react-bootstrap";
import Spinner from "react-bootstrap/Spinner";

type Props = {
    show : boolean;
    handleConfirm : () => void;
};

const AutoLogoutModal = ({
    show,
    handleConfirm
} : Props) => {
    const [loading, setLoading] = useState<boolean>(false);

    return (
        <ModalBase
            show={show}
            title=""
            size="lg"
            hideConfirmButton={true}
            hideCloseButton={true}
            handleClose={handleConfirm}
        >
            <Row className="chris-form-bg mx-0 py-3 px-2">
                <Col xs={12}>Your session will expire in 1 minute due to inactivity. Do you wish to continue?</Col>
            </Row>
            <Col xs={12}><hr /></Col>
            <Row className="mx-0 mt-2">
                <Col xs={12} className="d-flex flex-row justify-content-start justify-content-lg-end">
                    <Button
                        variant="secondary"
                        type="button"
                        className="d-flex pt-2 flex-row align-content-center"
                        onClick={async () => {
                            setLoading(true);
                            await handleConfirm();
                        }}
                    >{loading ? <React.Fragment>
                        <Spinner animation="border" size="sm" className="mt-1"/>
                        &nbsp; Resetting
                    </React.Fragment> : 'Yes, Continue Session'}</Button>
                </Col>
            </Row>
        </ModalBase>);
}

export default AutoLogoutModal;